import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URLS } from '../config/api.urls';

@Injectable()
export class CityService {
  constructor(private http: HttpClient) {}

  getCitiesByCountry(countryId: number): Observable<any[]> {
    return this.http.get<any[]>(`${API_URLS.CITIES_BASE_URL}?countryId=${countryId}`);
  }
}
